/* global System */

export default {
  MagazinRatgeber: () =>
    System.import(/* webpackChunkName: "MagazinRatgeber" */ './Component'),
}
